/**
 * The number on the sidebar's Community badge.
 *
 * Two surfaces show it now: the nav badge and Home's community card, and they must agree, so
 * the derivation lives here rather than once in each.
 *
 * Badges count ALL unread including muted conversations, because a mute suppresses the toast,
 * not the fact that something happened (see community-realtime.ts useUserChannel). The one
 * thing that zeroes it is the user turning channel messages off altogether.
 */
import { useMemo } from 'react';
import { useUnreadCounts } from '@/api/community-hooks';
import { useNotificationPreferences } from '@/api/hooks';

/** Community channels and group chats. DMs have their own badge and are not counted here. */
const COMMUNITY_TYPES = new Set(['community_channel', 'group']);

export function useCommunityUnread(): number {
  const { data: unreadCounts } = useUnreadCounts();
  const { data: prefs } = useNotificationPreferences();
  return useMemo(() => {
    if (prefs && !prefs.channel_messages) return 0;
    return unreadCounts?.filter((c) => COMMUNITY_TYPES.has(c.type)).reduce((sum, c) => sum + c.count, 0) ?? 0;
  }, [unreadCounts, prefs]);
}
